import type { MouseEventHandler } from 'react';
import { useCallback } from 'react';

import { useKeyDown } from '../../hooks/useKeyDown';
import { useNewGame } from '../../hooks/useNewGame';
import { reset } from '../../reducers/game';
import { currentWordSelector, errorSelector } from '../../selectors/game';
import { useAppDispatch, useAppSelector } from '../../store';
import { Button } from '../button/Button';
import { KeyboardHint } from '../keyboard-hint/KeyboardHint';

export const ErrorMessage = (): JSX.Element => {
  const currentWord = useAppSelector(currentWordSelector);
  const error = useAppSelector(errorSelector);
  const dispatch = useAppDispatch();

  const startNewGame = useNewGame();

  const goHome = useCallback(() => {
    dispatch(reset());
  }, [dispatch]);

  useKeyDown('Enter', startNewGame);
  useKeyDown('Escape', goHome);

  const onClickReset: MouseEventHandler<HTMLButtonElement> = () => {
    goHome();
  };

  const onClickNewGame: MouseEventHandler<HTMLButtonElement> = () => {
    startNewGame();
  };

  return (
    <div style={{ padding: '32px', textAlign: 'center' }}>
      {error}
      <br />
      Word was: <span style={{ fontWeight: '700' }}>{currentWord?.toUpperCase()}</span>
      <br />
      <br />
      <Button onClick={onClickReset} style={{ backgroundColor: '#2196f3' }}>
        Home
      </Button>
      <Button onClick={onClickNewGame} style={{ backgroundColor: '#2196f3' }}>
        New Game
      </Button>
      <KeyboardHint>Press enter for a new game, or escape to go home</KeyboardHint>
    </div>
  );
};
